import secureLocalStorage from "react-secure-storage";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { Component } from "react";
import Api from "../../Services/Api";

export default class ExportHeatmapViewActionRiskDataset extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.init();
  }

  init=async()=>{
    
    if(this.props.isFreezeDS){
      if (this.props.chartData && !this.props.chartData.isActionWidget) {
        await this.getImpactRatingTable();
        this.getFrozenRiskDataByViewId(this.props.chartData);
      }
    }else{
      if (this.props.chartData && !this.props.chartData.isActionWidget) {
        await this.getImpactRatingTable();
        await this.getRiskDataByViewId(this.props.chartData);
      }
    }
    
  }

  
  getImpactRatingTable = async () => {
    try {
      var req = {
        WorkstreamId:0,
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200) {
        let arr = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <Column
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From (%)"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            // editable={index === 0 ? false : true}
          />
        ));
        this.setState({
          loader: false,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
          rangeList: [probabilityObj],
          probabilityColumns: rangeArray,
        });
      } 
    } catch (error) {
      console.error(error);
    }
  };

  
  getFrozenRiskDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        id: viewData.dataSourceId,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getFrozenDataset(requestParams);
      if (response.status == 200&&response.datasetResponse) {
        var riskRegister=await this.toCamel(response.datasetResponse[0]);       
        this.setState({
          ...this.state,
          riskList: riskRegister,
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskList1: [],
          loader: false,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  toCamel=(o)=> {
    var newO, origKey, newKey, value
    if (o instanceof Array) {
      return o.map((value)=> {
          if (typeof value === "object") {
            value = this.toCamel(value)
          }
          return value
      })
    } else {
      newO = {}
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
          value = o[origKey]
          if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = this.toCamel(value)
          }
          newO[newKey] = value
        }
      }
    }
    return newO
  }

  getRiskDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      
      let requestParams = null;
      if (viewData.timeStamp) {
        requestParams = {
          ViewId: viewData.dataSourceId,
          CreatedBy: parseInt(createdby),
          WidgetId: viewData.widgetId
        };
      } else {
        requestParams = {
          ViewId: viewData.dataSourceId,
          CreatedBy: parseInt(createdby),
          WidgetId: viewData.widgetId
        };
      }

      this.setState({ ...this.state, loader: true });
      let response = null;
      if (viewData.timeStamp) {
        response = await Api.getTimestampHeatMapByViewId(requestParams);
      } else {
        response = await Api.getHeatMapByViewId(requestParams);
      }

      if (response.status == 200) {
        this.setState({
          ...this.state,
          riskList: response.riskRegister,
          riskList1: viewData.timeStamp ? response.riskRegister1 : [],
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskList1: [],
          loader: false,
        });
      }
      this.filterImpactData(viewData);
      if (viewData.timeStamp) {
        this.filterImpactDataForTimestamp(viewData);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  filterImpactData = (_viewData) => {
    var tempData = [];
    this.state.riskList.map((res, resIndex) => {
      if (res.impactResponse && res.impactResponse.length > 0) {
        if (_viewData.impactId === 0) {
          // res.impactResponse.map((resImp, resImpIndex) => {
        // console.log("resImp",resImp)
            var temp = {
              frequency: res.frequency,
              currentProbability:res.currentProbability,
              pre: this.stingModifyPre(res.overAll),
              reductionProbability: res.reductionProbability,
              post: this.stingModifyPost(res.overAll),
              current: this.stingModifyCurrent(res.overAll),
              number: res.number,
              riskTitle: res.riskTitle,
              impactTitle:null
            };
            tempData.push(temp);
          // });
        } else {
          res.impactResponse.map((resImp, resImpIndex) => {
            if (resImp.impactId === _viewData.impactId ) {
              var temp = {
                frequency: res.frequency,
                currentProbability:res.currentProbability,
                pre: this.stingModifyPre(resImp.overAll),
                reductionProbability: res.reductionProbability,
                post: this.stingModifyPost(resImp.overAll),
                current: this.stingModifyCurrent(resImp.overAll),
                number: res.number,
                riskTitle: res.riskTitle,
               impactTitle: resImp.name 
              };
              tempData.push(temp);
            }
          });
        }
      }
    });
    
    this.setState({
      ...this.state,
      fiteredRiskList: tempData
    });
  }

  filterImpactDataForTimestamp = (_viewData) => {
    var tempData = [];
    this.state.riskList1.map((res, resIndex) => {
      if (res.impactResponse && res.impactResponse.length > 0) {
        if (_viewData.impactId === 0) {
          // res.impactResponse.map((resImp, resImpIndex) => {
            var temp = {
              frequency: res.frequency,
              currentProbability:res.currentProbability,
              pre: this.stingModifyPre(res.overAll),
              reductionProbability: res.reductionProbability,
              post: this.stingModifyPost(res.overAll),
              current: this.stingModifyCurrent(res.overAll),
              number: res.number,
              riskTitle: res.riskTitle,
              impactTitle:null
            };
            tempData.push(temp);
          // });
        } else {
          res.impactResponse.map((resImp, resImpIndex) => {
            if (resImp.impactId === _viewData.impactId) {
              var temp = {
                frequency: res.frequency,
                currentProbability:res.currentProbability,
                pre: this.stingModifyPre(resImp.overAll),
                reductionProbability: res.reductionProbability,
                post: this.stingModifyPost(resImp.overAll),
                current: this.stingModifyCurrent(resImp.overAll),
                number: res.number,
                riskTitle: res.riskTitle,
                impactTitle: resImp.name
              };
              tempData.push(temp);
            }
          });
        }
      }
    });
    
    this.setState({
      ...this.state,
      fiteredRiskListForTimestamp: tempData
    });
  }

  stingModifyPre = (value) => {
    const splitedStr=value.split('-');
    return splitedStr && splitedStr.length > 0 && splitedStr[0] != '' ? splitedStr[0] : '';
  }

  stingModifyPost = (value) => {
    const splitedStr=value.split('-');
    var val=(/\(([^)]+)\)/) ;
    // console.log("splitedStr",splitedStr) 
  //   const finalsplitedStr = splitedStr && splitedStr.length > 0 && splitedStr[1] != '' ?
  //   splitedStr[1].substring(1,splitedStr[1].length - 1) : '';
  //   return finalsplitedStr;
  // } 
  var val1, temp;
  if (splitedStr && splitedStr.length > 0 && splitedStr[1] != "") {
    if ((val1 = val.exec(splitedStr)[1])) {
      temp = val1;
    }
    const finalsplitedStr = temp;
    return finalsplitedStr;
  } 

}
stingModifyCurrent = (value) => {
  if (value && value.includes("{")) {
    let temp = value.split("{");
    if (temp && temp.length > 0) {
      return temp[1].slice(0, -1);
    }
  }
  return "";
}


  onEditCell() {}
  render() {
    return (
      <div>
        {/* {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null} */}
        <label style={{color: '#FFFFFF', marginBottom: '10px', fontSize: '16px'}}>Dataset</label>
        <div className="tblCont  dataGrids reportsGrid heatmapGrid">
          <Grid
            data={this.state.fiteredRiskList}
            resizable
          >
            <Column field="frequency" title="Pre Probability" width="25px" />
            <Column field="pre" title="Pre Severity" width="20px" />
            <Column field="current" title="Current Severity" width="20px" />
            <Column field="post" title="Post Severity" width="20px" />
            <Column field="currentProbability" title="Current Probability" width="25px" />
            <Column field="current" title="Current Severity" width="20px" />
            <Column field="reductionProbability" title="Post Probability" width="25px" />
            {this.props.chartData.xName ==="Impact$$All Impacts"?null :<Column field="impactTitle" title="Impact Title" width="35px" />}
            <Column field="number" title="Risk Number" width="30px" />
            <Column field="riskTitle" title="Risk Title" width="40px" />
          </Grid>
        </div>

        <br></br>

        {this.props.chartData.timeStamp ? (
          <div className="tblCont  dataGrids reportsGrid heatmapGrid">
            <Grid
              
              data={this.state.fiteredRiskListForTimestamp}
              resizable
            >
              <Column field="frequency" title="Pre Probability" width="25px" />
              <Column field="pre" title="Pre Severity" width="20px" />
              <Column field="currentProbability" title="Current Probability" width="25px" />
             <Column field="current" title="Current Severity" width="20px" />
              <Column field="reductionProbability" title="Post Probability" width="25px" />
              <Column field="post" title="Post Severity" width="20px" />
              {this.props.chartData.xName ==="Impact$$All Impacts"?null :<Column field="impactTitle" title="Impact Title" width="35px" />}
              <Column field="number" title="Risk Number" width="30px" />
              <Column field="riskTitle" title="Risk Title" width="40px" />
            </Grid>
            <br></br>
          </div>
        ) : ("")}

        <div className="rw-tab-content">
          <label style={{color: '#FFFFFF', textAlign: 'left'}}>Probability Range</label>
          <div className="tblCont  dataGrids reportsGrid">
          <Grid data={this.state.rangeList}>
          {this.state.probabilityColumns}
          </Grid>
          </div>
        </div>
      </div>
    );
  }
}
